export const mapStyle = [
  {
    "featureType": "All",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#f5f5f5"
      }
    ]
  },
  {
    "featureType": "All",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#CFE8FF"
      }
    ]
  },
    // {
    //   "featureType": "road",
    //   "elementType": "geometry.fill",
    //   "stylers": [
    //     {
    //       "color": "#ffffff"
    //     }
    //   ]
    // },
    {
      "featureType": "road",
      "elementType": "all",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "administrative.province",
      "elementType": "all",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "administrative.locality",
      "elementType": "all",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#EAF4FF"
        }
      ]
    },
   
  ];